import httpService from "@/utils/request";

const authService = {
    /**
     * 用户登录接口
     * @param username 用户名
     * @param password 密码
     */
    login(username: String, password: String) {
        const url = "/auth/jwt/token";
        let dto = {
            username,
            password
        }
        return httpService.post(url, dto);
    },
    validateCASSTToken(token: String, serviceUrl: String) {
        const url = "/auth/jwt/cas/serviceToken";
        let dto = {
            serviceToken: token,
            serviceUrl
        }
        return httpService.post(url, dto);
    },
    getIndustryNewsPageListByParams: (params: any) => {
        const url = "/weChat/getIndustryNewsPageListByParams";
        return httpService.post(url, params);
    },
    getMyConstructionParkInfoList: () => {
        const url = "/operating/user/getMyConstructionParkInfoList";
        return httpService.get(url);
    },
    getLoginUserInfo: () => {
        const url = "/admin/user/loginUserInfo";
        return httpService.get(url);
    },
    getModuleServiceList: () => {
        const url = "/operating/moduleService/getModuleServiceList";
        return httpService.get(url);
    },
    updateUserInfo: (params: any) => {
        const url = "/admin/user/updateUser";
        return httpService.post(url, params);
    },

    updatePwd: (params: any) => {
        const url = "/admin/user/updatePwd";
        return httpService.post(url, params);
    },

    getOrgList: () => {
        const url = "/admin/organization/getOrgList";
        return httpService.get(url);
    },
}

export default authService;
